import * as R from "ramda";
import { DATAFLOW_ANNOTATIONS_PATH, MICRODATA } from "./constants/annotations.mjs";
const parseMicrodataAnnotation = (type) => (structure) => R.pipe(
  R.pathOr([], DATAFLOW_ANNOTATIONS_PATH),
  R.find(R.propEq(R.defaultTo(MICRODATA, type), "type")),
  R.ifElse(R.isNil, R.always({}), R.identity),
  R.prop("title")
)(structure);
export {
  parseMicrodataAnnotation
};
